import { EventObject } from "@lib/titan2/dist/util/event/EventObject";
/**
 * GameEvent.ts
 */
export class GameEvent {
    static createUserchoiceMadeEvent(payload) {
        return new EventObject(GameEvent.USER_CHOICE_MADE.getType(), payload);
    }
}
GameEvent.USER_CHOICE_MADE = new EventObject("GameEvent.USER_CHOICE_MADE");
GameEvent.FEATURE_DIALOG_REQUEST = new EventObject("GameEvent.FEATURE_DIALOG_REQUEST");
GameEvent.HELP_HIDE_BASEGAME = new EventObject("GameEvent.HELP_HIDE_BASEGAME");
GameEvent.HELP_SHOW_BASEGAME = new EventObject("GameEvent.HELP_SHOW_BASEGAME");
GameEvent.FEATURE_REQUEST = new EventObject("GameEvent.FEATURE_REQUEST");
GameEvent.FEATURE_START = new EventObject("GameEvent.FEATURE_START");
GameEvent.FEATURE_END = new EventObject("GameEvent.FEATURE_END");
GameEvent.TICKET_TRANSITION_OUT = new EventObject("GameEvent.TICKET_TRANSITION_OUT");
GameEvent.TICKET_TRANSITION_OUT_COMPLETE = new EventObject("GameEvent.TICKET_TRANSITION_OUT_COMPLETE");
GameEvent.TICKET_TRANSITION_IN = new EventObject("GameEvent.TICKET_TRANSITION_IN");
GameEvent.TICKET_TRANSITION_IN_COMPLETE = new EventObject("GameEvent.TICKET_TRANSITION_IN_COMPLETE");
GameEvent.FEATURE_WHEEL_IN = new EventObject("GameEvent.FEATURE_WHEEL_IN");
GameEvent.FEATURE_WHEEL_IN_COMPLETE = new EventObject("GameEvent.FEATURE_WHEEL_IN_COMPLETE");
GameEvent.FEATURE_WHEEL_OUT = new EventObject("GameEvent.FEATURE_WHEEL_OUT");
GameEvent.FEATURE_WHEEL_OUT_COMPLETE = new EventObject("GameEvent.FEATURE_WHEEL_OUT_COMPLETE");
GameEvent.FEATURE_REELS_IN = new EventObject("GameEvent.FEATURE_REELS_IN");
GameEvent.FEATURE_REELS_IN_COMPLETE = new EventObject("GameEvent.FEATURE_REELS_IN_COMPLETE");
GameEvent.FEATURE_REELS_OUT = new EventObject("GameEvent.FEATURE_REELS_OUT");
GameEvent.FEATURE_REELS_OUT_COMPLETE = new EventObject("GameEvent.FEATURE_REELS_OUT_COMPLETE");
GameEvent.FEATURE_TRANSITION_IN = new EventObject("GameEvent.FEATURE_TRANSITION_IN");
GameEvent.FREE_SPIN_REELS_RECOVER = new EventObject("GameEvent.FREE_SPIN_REELS_RECOVER");
GameEvent.COIN_WIN_START = new EventObject("GameEvent.COIN_WIN_START");
GameEvent.COIN_WIN_UPDATE_TOTAL = new EventObject("GameEvent.COIN_WIN_UPDATE_TOTAL");
GameEvent.COIN_WIN_COMPLETE = new EventObject("GameEvent.COIN_WIN_COMPLETE");
export class FreeSpinReelControllerEvent {
}
FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_IN_START = new EventObject("FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_IN_START");
FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_IN_COMPLETE = new EventObject("FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_IN_COMPLETE");
FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_OUT_START = new EventObject("FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_OUT_START");
FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_OUT_COMPLETE = new EventObject("FreeSpinReelControllerEvent.FREE_SPIN_TRANSITION_OUT_COMPLETE");
FreeSpinReelControllerEvent.FREE_SPIN_RETRIGGER_START = new EventObject("FreeSpinReelControllerEvent.FREE_SPIN_RETRIGGER_START");
FreeSpinReelControllerEvent.FREE_SPIN_RETRIGGER_COMPLETE = new EventObject("FreeSpinReelControllerEvent.FREE_SPIN_RETRIGGER_COMPLETE");
FreeSpinReelControllerEvent.FREE_SPIN_GAME_OVER_TRANSITION_OUT_START = new EventObject("FreeSpinReelControllerEvent.FREE_SPIN_GAME_OVER_TRANSITION_OUT_START");
FreeSpinReelControllerEvent.FREE_SPIN_GAME_OVER_TRANSITION_OUT_COMPLETE = new EventObject("FreeSpinReelControllerEvent.FREE_SPIN_GAME_OVER_TRANSITION_OUT_COMPLETE");
export class FreeSpinsRemainingViewEvent {
}
FreeSpinsRemainingViewEvent.ACTIVATE = new EventObject("FreeSpinsRemainingViewEvent.ACTIVATE");
FreeSpinsRemainingViewEvent.DEACTIVATE = new EventObject("FreeSpinsRemainingViewEvent.DEACTIVATE");
export class SpinsRemainingViewEvent {
}
SpinsRemainingViewEvent.FREE_SPIN_REELS_START = new EventObject("SpinsRemainingViewEvent.RAINBOW_REELS_DEFOCUS");
SpinsRemainingViewEvent.FREE_SPIN_REELS_END = new EventObject("SpinsRemainingViewEvent.RAINBOW_REELS_FOCUS");
export class TicketViewEvent {
}
TicketViewEvent.SLINGO_TICKET_ANIMATION = new EventObject("TicketViewEvent.SLINGO_TICKET_ANIMATION");
TicketViewEvent.SLINGO_TICKET_ANIMATION_COMPLETE = new EventObject("TicketViewEvent.SLINGO_TICKET_ANIMATION_COMPLETE");
export class FreeSpinsOverlayViewEvent {
}
FreeSpinsOverlayViewEvent.TRIGGER_COLLECTION = new EventObject("FreeSpinsOverlayViewEvent.TRIGGER_COLLECTION");
FreeSpinsOverlayViewEvent.COLLECTION_COMPLETE = new EventObject("FreeSpinsOverlayViewEvent.COLLECTION_COMPLETE");
/**
 * FeatureEvent.ts
 */
export class FeatureEvent {
}
FeatureEvent.SHOW_START = new EventObject("FeatureEvent.SHOW_START");
FeatureEvent.HIDE_START = new EventObject("FeatureEvent.HIDE_START");
FeatureEvent.HIDE_CONTROLS = new EventObject("FeatureEvent.HIDE_CONTROLS");
FeatureEvent.SPIN_REQUEST = new EventObject("FeatureEvent.SPIN_REQUEST");
FeatureEvent.SPIN_STARTED = new EventObject("FeatureEvent.SPIN_STARTED");
FeatureEvent.SPIN_STOPPED = new EventObject("FeatureEvent.SPIN_STOPPED");
FeatureEvent.REEL_RESOLVED = new EventObject("FeatureEvent.REEL_RESOLVED");
FeatureEvent.SPIN_COMPLETE = new EventObject("FeatureEvent.SPIN_COMPLETE");
FeatureEvent.SLOTS_COMPLETE = new EventObject("FeatureEvent.SLOTS_COMPLETE");
FeatureEvent.SLOTS_COMPLETE_COMPLETE = new EventObject("FeatureEvent.SLOTS_COMPLETE_COMPLETE");
FeatureEvent.SUMMARY = new EventObject("FeatureEvent.SUMMARY");
FeatureEvent.SUMMARY_COUNT_START = new EventObject("FeatureEvent.SUMMARY_COUNT_START");
FeatureEvent.SUMMARY_COUNT_END = new EventObject("FeatureEvent.SUMMARY_COUNT_END");
FeatureEvent.SUMMARY_COMPLETE = new EventObject("FeatureEvent.SUMMARY_COMPLETE");
FeatureEvent.WHEEL_IN = new EventObject("FeatureEvent.WHEEL_IN");
FeatureEvent.WHEEL_OUT_COMPLETE = new EventObject("FeatureEvent.WHEEL_OUT_COMPLETE");
FeatureEvent.BACKGROUND_DARK = new EventObject("FeatureEvent.BACKGROUND_DARK");
FeatureEvent.BACKGROUND_DAY = new EventObject("FeatureEvent.BACKGROUND_DAY");
//audio
FeatureEvent.REEL_START = new EventObject("FeatureEvent.REEL_START");
FeatureEvent.REEL_LOOP = new EventObject("FeatureEvent.REEL_LOOP");
FeatureEvent.REEL_STOP = new EventObject("FeatureEvent.REEL_STOP");
FeatureEvent.REEL_STOP_LAST = new EventObject("FeatureEvent.REEL_STOP_LAST");
FeatureEvent.REEL_SYMBOL_LAND = new EventObject("FeatureEvent.REEL_SYMBOL_LAND");
FeatureEvent.REEL_SYMBOL_OPEN = new EventObject("FeatureEvent.REEL_SYMBOL_OPEN");
FeatureEvent.REEL_SYMBOL_ACTION = new EventObject("FeatureEvent.REEL_SYMBOL_ACTION");
FeatureEvent.REEL_SYMBOL_CLOSE = new EventObject("FeatureEvent.REEL_SYMBOL_CLOSE");
FeatureEvent.WHEEL_SPIN = new EventObject("FeatureEvent.WHEEL_SPIN");
FeatureEvent.WHEEL_STOP = new EventObject("FeatureEvent.WHEEL_STOP");
FeatureEvent.REEL_VALUE_UPDATE = new EventObject("FeatureEvent.REEL_VALUE_UPDATE");
FeatureEvent.WIN_COUNT = new EventObject("FeatureEvent.WIN_COUNT");
FeatureEvent.WIN_COUNT_BIG = new EventObject("FeatureEvent.WIN_COUNT_BIG");
FeatureEvent.WIN_COUNT_MEGA = new EventObject("FeatureEvent.WIN_COUNT_MEGA");
FeatureEvent.WIN_COUNT_EPIC = new EventObject("FeatureEvent.WIN_COUNT_EPIC");
FeatureEvent.WIN_COUNT_EXPLOSIVE = new EventObject("FeatureEvent.WIN_COUNT_EXPLOSIVE");
FeatureEvent.WIN_COUNT_COMPLETE = new EventObject("FeatureEvent.WIN_COUNT_COMPLETE");
/**
 * FeatureReelEvent.ts
 */
export class FeatureReelEvent {
}
FeatureReelEvent.SHOW_CONTROLS = new EventObject("FeatureReelEvent.SHOW_CONTROLS");
FeatureReelEvent.SHOW_CONTROLS_COMPLETE = new EventObject("FeatureEvent.SHOW_CONTROLS_COMPLETE");
FeatureReelEvent.HIDE_CONTROLS = new EventObject("FeatureReelEvent.HIDE_CONTROLS");
FeatureReelEvent.HIDE_CONTROLS_COMPLETE = new EventObject("FeatureEvent.HIDE_CONTROLS_COMPLETE");
FeatureReelEvent.SPIN = new EventObject("FeatureReelEvent.SPIN");
FeatureReelEvent.STOP = new EventObject("FeatureReelEvent.STOP");
FeatureReelEvent.RESOLVE = new EventObject("FeatureReelEvent.RESOLVE");
/**
 * FeatureWheelEvent.ts
 */
export class FeatureWheelEvent {
}
FeatureWheelEvent.SPIN = new EventObject("FeatureWheelEvent.SPIN");
FeatureWheelEvent.HIDE = new EventObject("FeatureWheelEvent.HIDE");
FeatureWheelEvent.SLOT_TRIGGERED = new EventObject("FeatureWheelEvent.SLOT_TRIGGERED");
FeatureWheelEvent.PRIZE_TRIGGERED = new EventObject("FeatureWheelEvent.PRIZE_TRIGGERED");
FeatureWheelEvent.OUT_COMPLETE = new EventObject("FeatureWheelEvent.OUT_COMPLETE");
export class SoundEvent {
}
SoundEvent.BIG_WIN_START = new EventObject("SoundEvent.BIG_WIN_START");
SoundEvent.BIG_WIN_STOP = new EventObject("SoundEvent.BIG_WIN_STOP");
SoundEvent.BIG_WIN_THRESHOLD = new EventObject("SoundEvent.BIG_WIN_THRESHOLD");
SoundEvent.GREEN_FISH_WHIRLPOOL_APPEAR = new EventObject("SoundEvent.GREEN_FISH_WHIRLPOOL_APPEAR");
SoundEvent.GREEN_FISH_WHIRLPOOL_COLLECT_STING = new EventObject("SoundEvent.GREEN_FISH_WHIRLPOOL_COLLECT_STING");
SoundEvent.BUBBLE_APPEAR = new EventObject("SoundEvent.BUBBLE_APPEAR");
SoundEvent.BUBBLE_POP = new EventObject("SoundEvent.BUBBLE_POP");
SoundEvent.BUBBLE_STRETCH_POP = new EventObject("SoundEvent.BUBBLE_STRETCH_POP");
SoundEvent.BUBBLE_DISAPPEAR = new EventObject("SoundEvent.BUBBLE_DISAPPEAR");
SoundEvent.BUBBLE_RISE_LONG = new EventObject("SoundEvent.BUBBLE_RISE_LONG");
SoundEvent.BUBBLE_RISE = new EventObject("SoundEvent.BUBBLE_RISE");
SoundEvent.FISH_KISS = new EventObject("SoundEvent.FISH_KISS");
SoundEvent.FISH_SWIM = new EventObject("SoundEvent.FISH_SWIM");
SoundEvent.CLICK = new EventObject("SoundEvent.CLICK");
SoundEvent.COLLECT_BONUS = new EventObject("SoundEvent.COLLECT_BONUS");
SoundEvent.FISHFOOD_REVEAL_PICK = new EventObject("SoundEvent.FISHFOOD_REVEAL_PICK");
SoundEvent.GOLD_TALLY = new EventObject("SoundEvent.GOLD_TALLY");
SoundEvent.BLUE_TALLY = new EventObject("SoundEvent.BLUE_TALLY");
SoundEvent.GREEN_TALLY = new EventObject("SoundEvent.GREEN_TALLY");
SoundEvent.RED_TALLY = new EventObject("SoundEvent.RED_TALLY");
SoundEvent.PURPLE_TALLY = new EventObject("SoundEvent.PURPLE_TALLY");
SoundEvent.FISH_DIVE = new EventObject("SoundEvent.FISH_DIVE");
SoundEvent.SPINS_LEFT = new EventObject("SoundEvent.SPINS_LEFT");
SoundEvent.GOLDFISH_MULTIPLIER = new EventObject("SoundEvent.GOLDFISH_MULTIPLIER");
SoundEvent.BANGUP_BLUE_FISH_START = new EventObject("SoundEvent.BANGUP_BLUE_FISH_START");
SoundEvent.BANGUP_BLUE_FISH_END = new EventObject("SoundEvent.BANGUP_BLUE_FISH_END");
SoundEvent.BANGUP_GOLD_FISH_START = new EventObject("SoundEvent.BANGUP_GOLD_FISH_START");
SoundEvent.BANGUP_GOLD_FISH_END = new EventObject("SoundEvent.BANGUP_GOLD_FISH_END");
SoundEvent.GOLDFISH_REEL_STOP = new EventObject("SoundEvent.GOLDFISH_REEL_STOP");
SoundEvent.GOLDFISH_LOCK_REELS = new EventObject("SoundEvent.GOLDFISH_LOCK_REELS");
//# sourceMappingURL=GameEvent.js.map